import dynamic from 'next/dynamic'
import LazyLoad from 'react-lazyload'
import Box from '@mui/material/Box'

const moduleMap = {
  graphicFix: {
    component: dynamic(() => import('./GraphicGroup'), { ssr: false }),
    minHeight: 250,
  },
  graphicMore: {
    component: dynamic(() => import('./GraphicList'), { ssr: false }),
    minHeight: 250,
  },
  publicitySmall: {
    component: dynamic(() => import('./PublicitySmall'), { ssr: false }),
    minHeight: 385,
  },
  publicityLarge: {
    component: dynamic(() => import('./PublicityLarge'), { ssr: false }),
    minHeight: 500,
  },
  banner: {
    component: dynamic(() => import('./Banner'), { ssr: false }),
    minHeight: 190,
  },
  bannerLarge: {
    component: dynamic(() => import('./Picture'), { ssr: false }),
    minHeight: 100,
  },
  articleMainImage: {
    component: dynamic(() => import('./ArticleGroup'), { ssr: false }),
    minHeight: 400,
  },
  articleSmallImage: {
    component: dynamic(() => import('./ArticleList'), { ssr: false }),
    minHeight: 170,
  },
  customHtml: {
    component: dynamic(() => import('./CustomHTML'), { ssr: true }),
    minHeight: 1,
  },
  graphicN: {
    component: dynamic(() => import('./GraphicN'), { ssr: false }),
    minHeight: 250,
  },
}

const Present = ({ data, lazy, lazyOptions, isServicePage = false }) => {
  if (!moduleMap[data?.type]) {
    return null
  }
  const { component: DynamicModule, minHeight } = moduleMap[data?.type]
  const minHeightValue =
    typeof minHeight === 'function' ? minHeight(data) : minHeight

  if (lazy) {
    return (
      <LazyLoad
        height={minHeightValue}
        offset={lazyOptions?.offset ?? 0}
        scrollContainer={
          lazyOptions?.containerId && `#${lazyOptions.containerId}`
        }
      >
        <Box minHeight={minHeightValue}>
          <DynamicModule data={data} isServicePage={isServicePage} />
        </Box>
      </LazyLoad>
    )
  }

  return (
    <Box minHeight={minHeightValue}>
      <DynamicModule data={data} isServicePage={isServicePage} />
    </Box>
  )
}

Present.defaultProps = {
  lazy: false,
  lazyOptions: { offset: 0, containerId: '' },
}

export default Present
